<!--
 * 表格tooltip组件
 * @author 滕威
 * @time 2021-07-14
 *
-->
<!-- 模板(html)代码 start -->
<template>
  <!-- 文案溢出，显示tooltip -->
  <div
    id="table-toolTip"
    class="el-tooltip__popper is-dark"
    style="
      transform-origin: center top;
      z-index: 2003;
      position: fixed;
      display: none;
    "
  >
    <!--    <div class="content">-->
    {{ tableCellTooltipText }}
    <div class="popper__close" @click="fun_Close">
      <i class="el-icon-close"></i>
    </div>
    <div id="toolTip-arrow" class="popper__arrow"></div>
    <!--    </div>-->
  </div>
</template>
<!-- 模板(html)代码 end -->

<script>
export default {
  props: {
    tableCellMouse: {
      type: Object,
      default() {
        return {};
      }
    },
    isF: {
      type: Boolean,
      default: false
    },
    // tooltip组件dom元素
    num: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      toolDom: null,
      arrowDom: null,
      tableCellTooltipText: null // 溢出文案
      // mouseLeaveVal: {
      //   tooltip: 0, // 1-鼠标移入，2-鼠标移出，0-无焦点
      //   cell: false // 单元格
      // }
    };
  },

  watch: {
    // mouseLeaveVal: {
    //   deep: true,
    //   handler(nv) {
    //     setTimeout(() => {
    //       if (nv.cell && 1 != nv.tooltip) {
    //         this.fun_ToogleActiveTooltip(false, this.toolDom);
    //       }
    //     }, 100);
    //   }
    // },

    tableCellMouse: {
      deep: true,
      handler(nv, ov) {
        if (nv.hidden) {
          this.fun_HiddenTooltip();
        } else if (nv.row && !nv.hidden) {
          this.fun_ShowTooltip(nv.cellDom);
        }
      }
    },
    num: {
      handler(nv, ov) {
        if (nv) {
          this.num = nv;
          // console.log(typeof this.num - 1, this.num - 1)
          if (this.isF) {
            // 是
            this.toolDom = document.getElementsByClassName(
              "el-tooltip__popper"
            )[Number(this.num - 1)];
          } else {
            // 否
            this.toolDom = document.getElementById("table-toolTip");
          }
        }
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      // 是否是采购文件制作--评审项制作详情tabs嵌套页面
      if (this.isF) {
        // 是
        this.toolDom = document.getElementsByClassName("el-tooltip__popper")[
          Number(this.num - 1)
        ];
      } else {
        // 否
        this.toolDom = document.getElementById("table-toolTip");
      }
      this.arrowDom = document.getElementById("toolTip-arrow");
      // const _this = this;
      // this.toolDom.addEventListener("mouseleave", event => {
      //   _this.mouseLeaveVal.tooltip = 2;
      // });
      // this.toolDom.addEventListener("mouseenter", event => {
      //   _this.mouseLeaveVal.tooltip = 1;
      // });
    });
  },

  methods: {
    fun_Close() {
      this.toolDom.style.display = "none";
      this.tableCellMouse.cellDom = null;
      this.tableCellMouse.row = null;
      this.tableCellMouse.hidden = true;
    },
    // 文字溢出显示tooltip  动态计算top和left
    // clientWidth 表格单元格宽度
    fun_ShowTooltip(cell) {
      cell.style.position = "relative";
      this.tableCellTooltipText = cell.innerText || cell.textContent;
      const textWidth = this.fun_TextSize("12px", this.tableCellTooltipText);
      // textWidth 文字所占的宽度
      if (textWidth > cell.clientWidth - 35) {
        const cellLeft = cell.getBoundingClientRect().left,
          cellTop = cell.getBoundingClientRect().top;
        const computedPositonNum = this.fun_HiddenToolPosition(
          textWidth,
          cell.clientWidth,
          cellLeft,
          cellTop
        );
        this.toolDom.style.top = `${computedPositonNum.top}px`;
        this.toolDom.style.left = `${computedPositonNum.left}px`;
        this.toolDom.style.width = `${computedPositonNum.width}px`;
        this.arrowDom.style.left = `${computedPositonNum.arrowLeft}px`;
        // this.fun_ToogleActiveTooltip(true, this.toolDom);
        // this.mouseLeaveVal.cell = false;
        // this.mouseLeaveVal.tooltip = 0;
        this.toolDom.style.display = "";
      } else {
        this.toolDom.style.display = "none";
      }
    },

    // toolTip定位计算
    fun_HiddenToolPosition(txtWidth, cellWidth, cellLeft, cellTop) {
      // 算出tooltip的高度
      const toolHight = Math.ceil((txtWidth / 324) * 15 + 29),
        toolWidth = 300 < txtWidth ? 350 : txtWidth + 50,
        webWidth = document.body.offsetWidth;
      // const toolHight = Math.ceil(((txtWidth + 8) / 310) * 24),
      //     toolWidth = 300 < txtWidth ? 350 : (txtWidth + 50),
      //     webWidth = document.body.offsetWidth;
      // webHeight = document.body.offsetHeight;
      let expectLeft = cellLeft - (toolWidth - cellWidth) / 2;
      const toolWidthAndLeft = expectLeft + toolWidth,
        expectTop = cellTop - toolHight - 8;
      let arrowLeft; // arrow left
      if (toolWidthAndLeft > webWidth) {
        const moreWidth = toolWidthAndLeft - webWidth;
        expectLeft -= toolWidthAndLeft - webWidth;
        arrowLeft = (toolWidth - moreWidth) / 2 + moreWidth - 6;
      } else {
        arrowLeft = toolWidth / 2 - 6;
      }
      return { left: expectLeft, top: expectTop, width: toolWidth, arrowLeft };
    },

    fun_HiddenTooltip() {
      // this.mouseLeaveVal.cell = true;
      this.toolDom.style.display = "none";
      this.tableCellMouse.cellDom = null;
      this.tableCellMouse.row = null;
      this.tableCellMouse.hidden = true;
    },

    //tooltip样式
    // fun_ToogleActiveTooltip(show, toolDom) {
    //   if (show) {
    //     toolDom.classList.add(
    //       "el-fade-in-linear-enter-active",
    //       "el-fade-in-linear-enter-to",
    //       "el-popper"
    //     );
    //     setTimeout(() => {
    //       toolDom.classList.remove(
    //         "el-fade-in-linear-enter-active",
    //         "el-fade-in-linear-enter-to"
    //       );
    //     }, 500);
    //     toolDom.style.display = "";
    //   } else {
    //     toolDom.classList.add(
    //       "el-fade-in-linear-leave-active",
    //       "el-fade-in-linear-leave-to"
    //     );
    //     setTimeout(() => {
    //       toolDom.classList.remove(
    //         "el-fade-in-linear-leave-active",
    //         "el-fade-in-linear-leave-to",
    //         "el-popper"
    //       );
    //     }, 500);
    //     toolDom.style.display = "none";
    //   }
    // },

    fun_TextSize(fontSize, text) {
      const span = document.createElement("span");
      let width = span.offsetWidth;
      span.style.visibility = "hidden";
      span.style.fontSize = fontSize;
      span.style.display = "inline-block";
      document.body.appendChild(span);
      if ("undefined" != typeof span.textContent) {
        span.textContent = text;
      } else {
        span.innerText = text;
      }
      width = Math.ceil(span.clientWidth);
      document.body.removeChild(span);
      return width;
    }
  }
};
</script>

<style lang="scss" scoped>
#table-toolTip {
  max-width: 300px !important;
  box-sizing: border-box;
  position: relative;
  background: #ffffff;
  color: #000000;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  .popper__close {
    width: 18px;
    line-height: 16px;
    text-align: center;
    position: absolute;
    right: -6px;
    top: -7px;
    border-radius: 50%;
    border: 1px solid #d1d1d1;
    background: #ffffff;
    cursor: pointer;
    .el-icon-close {
      color: #d1d1d1;
      font-size: 12px;
    }
  }
  .popper__arrow {
    bottom: -6px;
    left: 50%;
    margin-right: 3px;
    border-bottom-width: 0;
    border-top-color: #ffffff;
    &::after {
      border-bottom-width: 0;
      border-top-color: #ffffff;
      bottom: 1px;
      margin-left: -6px;
    }
  }
}
</style>
